<template>
  <div class="wb-sidebar-menu-line-three-left">
    <div class="wb-sidebar-menu-price">
      {{price}} {{this.currencySymbol}}
    </div>
    <SidebarMenuItemCounter
        @count-add="addCount"
        @count-del="delCount"
        :value="data.count"
    />
    <div class="wb-sidebar-menu-cost">
      {{cost}} {{this.currencySymbol}}
    </div>
  </div>
</template>

<script>
import SidebarMenuItemCounter from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuItemCounter.vue';
import { useStoreData } from '@/Store/storeData';

export default {
  name: 'SidebarMenuItemBot3',
  components: {
    SidebarMenuItemCounter,
  },
  setup() {
    const storeData = useStoreData();

    return{
      storeData,
    };
  },
  computed: {
    cost() {
      let count = 0;
      let price = 0;
      if (this.count) {
        count = +this.count;
      }
      if (this.price) {
        price = +this.price;
      }
      return (Math.round(price * count * 100) / 100).toFixed(2);
    },
  },
  props: [
    'price',
    'data',
    'count',
    'currencySymbol',
  ],
  methods: {
    addCount() {
      this.storeData.setCategoriesItems(this.data.id, +1);
    },
    delCount() {
      this.storeData.setCategoriesItems(this.data.id, -1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "CSS/fonts.scss";
@import "CSS/colors.scss";
@import "CSS/animations.scss";
@import "CSS/common.scss";

.wb-sidebar-menu-line-three-left {
    display: grid;
    grid-template-columns: max-content max-content auto;
    grid-column-gap: 8px;
    width: 100%;
}

.wb-dnd-on-hover-anchor {
    width: 0;
}

.wb-dnd-on-hover-visible {
    //display: none;
    position: relative;
    right: 24px;
    color: transparent;
    @include button-smooth;
}

.wb-sidebar-menu-item:hover .wb-dnd-on-hover-visible{
    color: $green2;
}

</style>
